export default __webpack_public_path__ + "static/media/plan_dog.85c34122.svg";